import Dexie, {Table} from 'dexie';
import {Party} from "./_types/Party";

import {Params} from "./_types/Params";
import {PartyRules, LotoCardboard} from "./_types/LotoCardboard";
import {DrawRecord} from "./tickets/drawHistoryRepo";
import {LotoEvent} from "./_types/LotoEvent";
export class MyAppDatabase extends Dexie {
    party!: Table<Party, number>;
    params!: Table<Params, number>;
    lotoCardboards!: Table<LotoCardboard, string>;
    partyRules!: Table<PartyRules, number>;
    drawHistory!: Table<DrawRecord, number>;
    lotoEvents!: Table<LotoEvent, number>;
    constructor() {
        super('loto');
        this.version(1).stores({
            party: '++id, title, params',
            params: '++id, viewType',
        });

        this.version(2).stores({
            party: '++id, title, params',
            params: '++id, viewType',
            tickets: 'id, label, barcode, createdAt',
            partyRules: 'id, winMode',
        }).upgrade(async (tx) => {
            await tx.table("partyRules").add({id: 1, winMode: "line1"});
        });

        this.version(3).stores({
            party: '++id, title, params',
            params: '++id, viewType',
            tickets: 'id, label, barcode, createdAt',
            partyRules: 'id, winMode',
            drawHistory: '++id, number, createdAt'
        });

        this.version(4)
            .stores({
                party: '++id, eventId, partyNumber, title, params',
                params: '++id, viewType',
                tickets: 'id, label, barcode, createdAt',
                partyRules: 'id, winMode',
                drawHistory: '++id, number, createdAt',
                lotoEvents: '++id, name, createdAt',
            })
            .upgrade(async (tx) => {
                const eventsTable = tx.table("lotoEvents") as unknown as Table<LotoEvent, number>;
                const partyTable = tx.table("party") as unknown as Table<any, number>;

                const existingEvents = await eventsTable.toArray();
                const defaultEventId =
                    existingEvents.length > 0
                        ? (existingEvents[0].id ??
                          ((await eventsTable.add({name: "Événement", createdAt: new Date().toISOString()})) as number))
                        : ((await eventsTable.add({name: "Événement", createdAt: new Date().toISOString()})) as number);

                const parties = await partyTable.toArray();
                const sorted = [...parties].sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
                let counter = 1;

                for (const p of sorted) {
                    const changes: any = {};
                    if (typeof p.eventId !== "number") changes.eventId = defaultEventId;
                    if (typeof p.partyNumber !== "number") changes.partyNumber = counter++;
                    if (!p.title) {
                        const n = changes.partyNumber ?? p.partyNumber ?? counter;
                        changes.title = `Événement — Partie ${n}`;
                    }
                    if (Object.keys(changes).length) {
                        await partyTable.update(p.id, changes);
                    }
                }
            });

        this.lotoCardboards = this.table("tickets");
        this.lotoEvents = this.table("lotoEvents");
    }
}

export const db = new MyAppDatabase();
